import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../Styles/AboutUs.css';

const AboutUs = () => {
  const navigate = useNavigate();

  const handleContactUs = () => {
    window.location.href = 'mailto:contact@aiwaiter.com';
  };

  const handleTryDemo = () => {
    alert('Scan a QR code at any participating restaurant to experience AI Waiter!');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="about-us-container">
      <div className="about-content">
        {/* Hero Section */}
        <section className="hero-section">
          <h1 className="hero-title">AI WAITER</h1>
          <p className="hero-statement">
            We're revolutionizing restaurant ordering with voice AI that understands you like your favorite waiter.
          </p>
        </section>

        {/* Origin Story */}
        <section className="story-section">
          <h2>OUR STORY</h2>
          <p>
            It started with a simple frustration: waiting 20 minutes just to order a burger. 
            We thought, "What if you could just <em>tell</em> your order to your table?" 
            No flagging down servers. No complicated menus. Just natural conversation.
          </p>
          <p>
            That spark became AI Waiter—where every table has a voice-activated assistant 
            that knows the menu better than anyone and never keeps you waiting.
          </p>
        </section>

        {/* Mission & Vision */}
        <section className="mission-section">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <h3>MISSION</h3>
              <p>
                Making restaurant ordering as easy as having a conversation, 
                while giving servers more time to create memorable dining experiences.
              </p>
            </div>
            <div className="vision-card">
              <h3>VISION</h3>
              <p>
                A world where technology enhances human connection in dining, 
                not replaces it. Where "May I take your order?" happens instantly, every time.
              </p>
            </div>
          </div>
        </section>


        {/* What Makes Us Different */}
        <section className="difference-section">
          <h2>WHY AI WAITER?</h2>
          <div className="difference-content">
            <p className="main-difference">
              We're not just another ordering app. We <strong>understand context</strong>.
            </p>
            <ul className="difference-list">
              <li>"Make it spicy" → We know what you're talking about</li>
              <li>"Actually, cancel the fries" → Done, no hassle</li>
              <li>"Can you take out the pickles from by burger?" → Modifications made easy</li>
            </ul>
          </div>
        </section>

        {/* Call to Action */}
        <section className="cta-section">
          <h2>READY TO TRANSFORM YOUR DINING?</h2>
          <p className="cta-subtitle">
            For restaurants ready to leap forward, or diners tired of waiting.
          </p>
          <div className="cta-buttons">
            <button className="cta-primary" onClick={handleContactUs}>
              Partner With Us
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="about-footer">
          <p>© 2024 AI Waiter. No more standing.</p>
        </footer>
      </div>
    </div>
  );
};

export default AboutUs;